import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    tagline: "Todo lo que está pasando en tu ciudad, en un solo lugar. Curado para vivir Chile.",
    explore: "Explorar",
    allEvents: "Todos los eventos",
    organizations: "Organizaciones",
    freeEvents: "Eventos Gratis",
    musicEvents: "Eventos de Música",
    cultureEvents: "Eventos de Cultura",
    familyEvents: "Eventos Familiares",
    company: "Compañía",
    howItWorks: "Cómo funciona",
    suggestions: "Sugerencias",
    contact: "Contacto",
    terms: "Términos y Condiciones",
    privacy: "Privacidad",
    dataDeletion: "Eliminación de datos",
    cookiePreferences: "Preferencias de cookies",
    copyright: (year: number) => `© ${year} Ciudad Viva Chile. Hecho en Santiago.`,
    newsletterTitle: "Planes en tu correo cada semana",
    newsletterDone: "¡Listo! Te avisamos cada viernes y cada lunes.",
    emailPlaceholder: "tu@correo.cl",
    subscribe: "Suscribir",
    subscribeError: "No se pudo suscribir. Intenta más tarde.",
  },
  en: {
    tagline: "Everything happening in your city, in one place. Curated to enjoy Chile.",
    explore: "Explore",
    allEvents: "All events",
    organizations: "Organizations",
    freeEvents: "Free events",
    musicEvents: "Music events",
    cultureEvents: "Culture events",
    familyEvents: "Family events",
    company: "Company",
    howItWorks: "How it works",
    suggestions: "Suggestions",
    contact: "Contact",
    terms: "Terms and Conditions",
    privacy: "Privacy",
    dataDeletion: "Data deletion",
    cookiePreferences: "Cookie preferences",
    copyright: (year: number) => `© ${year} Ciudad Viva Chile. Made in Santiago.`,
    newsletterTitle: "Weekly plans in your inbox",
    newsletterDone: "Done! We'll write to you every Friday and Monday.",
    emailPlaceholder: "you@email.com",
    subscribe: "Subscribe",
    subscribeError: "Couldn't subscribe. Please try again later.",
  },
});
